export default __webpack_public_path__ + "static/media/prev-NavIC-Clock-1.d2920a0a.png";